import PuzzleService from '_services/rest/modules/puzzle';

export default {
  data() {
    return {
      templates: [],
      searchTimeoutId: null,
    };
  },
  methods: {
    onInputTemplate(name) {
      if (!name) {
        this.templates = [];
        if (this.onTemplateCleared) this.onTemplateCleared();
      }

      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getTemplates(name);
      }, 500);
    },
    getTemplates(name) {
      PuzzleService.getTemplates({
        search: name,
        slug: 'palavra-cruzadas',
      })
        .then(response => {
          this.templates = response;
        });
    },
  },
};
